import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllCustomersResponseModel, CustomersResponseModel } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Raw, Repository } from 'typeorm';
import { Address } from './address.entity';
import { Customers } from './customers.entity';
import { CustomerRequest } from './dto/customer.request';
import { CustomersAdapter } from './dto/customers.adapter';
import { CustomersDTO } from './dto/customers.dto';
import { UserRequestDto } from './dto/user-logs-dto';

@Injectable()
export class CustomersService {
    constructor(
      private logService:LogsService,

        @InjectRepository(Customers)
        private customersRepository: Repository<Customers>,
        @InjectRepository(Address)
        private addressRepository: Repository<Address>,
        private customersAdapter: CustomersAdapter,
    ) { }
    /**
     * create or update Customer
     * @param customersDTO 
     * @param isUpdate 
     * @param request 
     */
    async createCustomer(customersDTO: CustomersDTO, isUpdate: boolean): Promise<CustomersResponseModel> {
        try {
            // to check whether Customer exists with the passed  Customer  or not. if isUpdate is false, a check will be done whether a record with the passed Customer is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Customer  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
          let previousValue
            console.log(isUpdate);
            if (!isUpdate) {
            
                const CustomerEntity = await this.getCustomerDetailsWithoutRelations(customersDTO.clientCode);
                if (CustomerEntity) {
                    return new CustomersResponseModel(false,11104, 'Customer already exists');
                }
            
                // var notificationStatus='Created';
            }else{
                const customerPrevious = await this.customersRepository.findOne({where:{custId:customersDTO.custId}})
                previousValue = customerPrevious.clientName
            }
        
            const convertedCustomerEntity: Customers = this.customersAdapter.convertDtoToEntity(customersDTO, isUpdate);
            const savedCustomerEntity: Customers = await this.customersRepository.save(
                convertedCustomerEntity
            );
            const savedCustomerDto: CustomersDTO = this.customersAdapter.convertEntityToDto(savedCustomerEntity);
            if (savedCustomerDto) {
                const certificatePresent = savedCustomerDto.clientName;
                console.log(certificatePresent)
                // generating resposnse
                const response = new CustomersResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Customer Updated Successfully' : 'Customer Created Successfully', savedCustomerDto);
                const name=isUpdate?'updated':'created'
                const displayValue = isUpdate? 'Customer Updated Successfully': 'Customer Created Successfully'
            const userName = isUpdate? savedCustomerDto.updatedUser :savedCustomerDto.createdUser;
            const newLogDto = new LogsDto(1,name, 'Customers', savedCustomerDto.custId, true, displayValue,userName,previousValue,certificatePresent)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            
                return response;
            } else {
                throw new ErrorResponse(11106, 'Customer saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }
    /**
     * get customers by id
     * @param clientCode 
     */
    // @LogActions({isAsync: true})
    async getCustomerDetailsWithoutRelations(clientCode: string): Promise<Customers> {
        // tslint:disable-next-line: typedef
        const CustomersResponse = await this.customersRepository.findOne({
            where: { clientCode: Raw(alias => `client_code = '${clientCode}'`) },
        });
        if (CustomersResponse) {
            return CustomersResponse;
        } else {
            return null;
        }
    }
    /**
     * get All Customers Details
     */
    async getAllCustomers(req?:UserRequestDto): Promise<AllCustomersResponseModel> {
        // const page: number = 1;
        try {
            const customersDTO: CustomersDTO[] = [];
            //retrieves all companies
            const customersEntities: Customers[] = await this.customersRepository.find({ order: { 'clientName': 'ASC' },
            relations: [
                "cusAddressInfo",
              ]
         });
         console.log(customersEntities)
            if (customersEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                customersEntities.forEach(customerEntity => {
                    const convertedcustomersDto: CustomersDTO = this.customersAdapter.convertEntityToDto(
                        customerEntity
                    );
                    customersDTO.push(convertedcustomersDto);
                });
                const response = new AllCustomersResponseModel(true, 11108, "Customers retrieved successfully", customersDTO);
                if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'Customers', 0, true, 'Customers retrieved successfully',req.createdUser,'','')
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                }
             
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found'); customersDTO
            }
        } catch (err) {
            return err;
        }
    }
    async getAllActiveCustomers(): Promise<AllCustomersResponseModel> {
        // const page: number = 1;
        try {
            const customersDTO: CustomersDTO[] = [];
            //retrieves all companies
            const customersEntities: Customers[] = await this.customersRepository.find({ order: { 'clientName': 'ASC' },
            relations: [
                "cusAddressInfo",
              ],
              where:{isActive:true},
         });
         console.log(customersEntities)
            if (customersEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                customersEntities.forEach(customerEntity => {
                    const convertedcustomersDto: CustomersDTO = this.customersAdapter.convertEntityToDto(
                        customerEntity
                    );
                    customersDTO.push(convertedcustomersDto);
                });
                const response = new AllCustomersResponseModel(true, 11108, "Customers retrieved successfully", customersDTO);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found'); customersDTO
            }
        } catch (err) {
            return err;
        }
    }
    /**
     * Activate or Deactivate Customer
     * @param customerReq 
     */
    async activateOrDeactivateCustomer(customerReq: CustomerRequest): Promise<CustomersResponseModel> {
        try {
            const customerExists = await this.getCustomerById(customerReq.custId);
            if (customerExists) {
                if (customerReq.versionFlag !== customerExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Customer information.Refresh and try again');
                } else {

                    const customerStatus = await this.customersRepository.update(
                        { custId: customerReq.custId },
                        { isActive: customerReq.isActive, updatedUser: customerReq.updatedUser });

                    if (customerExists.isActive) {
                        if (customerStatus.affected) {
                            const customerResponse: CustomersResponseModel = new CustomersResponseModel(true, 10115, 'Customer is de-activated successfully');
                            return customerResponse;
                        } else {
                            throw new ErrorResponse(10111, 'Customer is already deactivated');
                        }
                    } else {
                        if (customerStatus.affected) {
                            const customerResponse: CustomersResponseModel = new CustomersResponseModel(true, 10114, 'Customer is activated successfully');
                            return customerResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Customer is already activated');
                        }
                    }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    /**
     * get Customer while passing id
     * @param custId 
     */
    async getCustomerById(custId: number): Promise<Customers> {
          const Response = await this.customersRepository.findOne({
          where: {custId: custId},
          });
          if (Response) {
          return Response;
          } else {
          return null;
          }
      }

      async getCustomerDataById(@Body() customerRequest:CustomerRequest): Promise<CustomersResponseModel> {
        // const page: number = 1;
        try {
//   console.log('hhhhhhhhhhhhhhhhhh Controller '+customerRequest.custId);  

          const customersDTO: CustomersDTO[] = [];
          //retrieves all companies
          const customersEntities: Customers = await this.customersRepository.findOne({
              relations:["cusAddressInfo"],
            where:{custId:customerRequest.custId}
            });
            const customersData: CustomersDTO = this.customersAdapter.convertEntityToDto(customersEntities);
            if (customersData) {
            console.log(customersData);

                const response = new CustomersResponseModel(true, 11101 , 'Customer retrived Successfully',customersData);
                return response;
            }
            else{
                throw new ErrorResponse(11106,'Something went wrong');
            }
            // generating resposnse
            
        } catch (err) {
            return err;
        }
      }
}
